/**
 * dash-api HTTP API base (no trailing slash).
 * - Default production: full URL
 * - Local dev: set `REACT_APP_API_URL=/api` so the browser uses same origin; the CRA dev
 *   server (`src/setupProxy.js`) forwards to the JVM and sets `X-AWP-API-Key` from `AWP_HTTP_API_KEY`.
 */
export function getApiBase() {
    const v = (process.env.REACT_APP_API_URL || 'https://awp.minsky.ai/api').trim();
    const normalized = (v || '/api').replace(/\/$/, '') || '/api';

    // When the UI is served from a different host than the baked-in API URL (e.g. dev.dash.minsky.ai UI
    // with REACT_APP_API_URL=https://awp.minsky.ai/api), use same-origin /api via the page reverse proxy.
    if (typeof window !== 'undefined' && window.location?.origin) {
        const pageOrigin = window.location.origin;

        if (normalized.startsWith('/')) {
            return `${pageOrigin}${normalized}`;
        }

        if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
            try {
                if (new URL(normalized).origin !== pageOrigin) {
                    return `${pageOrigin}/api`;
                }
            } catch {
                // keep configured value
            }
        }
    }

    return normalized;
}

/**
 * Origin for dash-api SockJS (path `/ws`). Not the dash Yjs / collaboration host.
 * Derives from {@link getApiBase} so dev UI on dev.dash.minsky.ai hits the same host for /api and /ws.
 */
export function getAwpBackendOrigin() {
    if (process.env.REACT_APP_AWP_BACKEND_ORIGIN) {
        return process.env.REACT_APP_AWP_BACKEND_ORIGIN.replace(/\/$/, '');
    }
    const apiBase = getApiBase();
    if (apiBase.startsWith('http://') || apiBase.startsWith('https://')) {
        return new URL(apiBase).origin;
    }
    if (typeof window !== 'undefined' && window.location?.origin) {
        return window.location.origin;
    }
    return 'https://awp.minsky.ai';
}
